import { Link, useNavigate } from "react-router-dom";
import { Mail, Phone, MapPin, ChevronUp } from "lucide-react";
const Footer = () => {
  const currentYear = new Date().getFullYear();
  const navigate = useNavigate();
  const footerLinks = {
    company: [{
      label: "Home",
      href: "home"
    }, {
      label: "Our Process",
      href: "/process"
    }, {
      label: "About",
      href: "/about"
    }, {
      label: "Contact",
      href: "/contact"
    }],
    services: [{
      label: "Growth Package",
      href: "/#packages"
    }, {
      label: "Scale Package",
      href: "/#packages"
    }, {
      label: "Enterprise Package",
      href: "/#packages"
    }, {
      label: "Custom Solutions",
      href: "/contact"
    }],
    resources: [{
      label: "ROI Calculator",
      href: "/#calculator"
    }, {
      label: "FAQ",
      href: "/#faq"
    }, {
      label: "Blog",
      href: "/blog"
    }, {
      label: "Back to Top",
      href: "top"
    }]
  };
  const handleNavigation = (href: string) => {
    if (href === "home") {
      // Handle Home link - scroll to top if on same page, navigate to home if on other page
      const currentPath = window.location.pathname;
      if (currentPath === "/") {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      } else {
        navigate("/");
      }
    } else if (href === "top") {
      // Handle Back to Top
      window.scrollTo({ top: 0, behavior: 'smooth' });
    } else if (href.startsWith("/#")) {
      // For hash links with slash, navigate to home first if not already there
      const hash = href.substring(1); // Remove the leading slash
      const currentPath = window.location.pathname;
      if (currentPath !== "/") {
        navigate("/");
        // Wait for navigation then scroll
        setTimeout(() => {
          const element = document.querySelector(hash);
          if (element) {
            element.scrollIntoView({ behavior: 'smooth', block: 'start' });
          }
        }, 100);
      } else {
        // Already on home page, just scroll
        const element = document.querySelector(hash);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }
    } else if (href.startsWith("#")) {
      // For regular hash links, only scroll if on same page
      const element = document.querySelector(href);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    } else {
      navigate(href);
    }
  };

  const renderFooterLink = (link: {
    label: string;
    href: string;
  }) => {
    if (link.href === "home" || link.href === "top" || link.href.startsWith("#") || link.href.startsWith("/#")) {
      return <button onClick={() => handleNavigation(link.href)} className="text-sm text-muted-foreground hover:text-foreground transition-colors flex items-center space-x-1">
          <span>{link.label}</span>
          {link.href === "top" && <ChevronUp className="h-3 w-3" />}
        </button>;
    } else {
      return <Link to={link.href} className="text-sm text-muted-foreground hover:text-foreground transition-colors">
          {link.label}
        </Link>;
    }
  };
  return <footer className="bg-background border-t border-border">
      <div className="container mx-auto px-4 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-8">
          {/* Brand Section */}
          <div className="lg:col-span-2">
            <h3 className="text-2xl font-display font-bold bg-gradient-brand bg-clip-text text-transparent mb-4">
              Contencraft
            </h3>
            <p className="text-muted-foreground mb-6 max-w-md">Stop renting content teams and start owning them. We are the only ones that builds you an in-house content team instead of keeping you dependent on retainers. One-time setup, lifetime capability.</p>
            
            {/* Contact Info */}
            <div className="space-y-3">
              <div className="flex items-center space-x-3 text-sm text-muted-foreground">
                <Mail className="h-4 w-4" />
                <span>hello@contencraft.com</span>
              </div>
              <div className="flex items-center space-x-3 text-sm text-muted-foreground">
                <Phone className="h-4 w-4" />
                <span>+91 7726020403</span>
              </div>
              <div className="flex items-center space-x-3 text-sm text-muted-foreground">
                <MapPin className="h-4 w-4" />
                <span>Available Worldwide</span>
              </div>
            </div>
          </div>

          {/* Company Links */}
          <div>
            <h4 className="font-semibold text-foreground mb-4">Company</h4>
            <ul className="space-y-3">
              {footerLinks.company.map(link => <li key={link.label}>
                  {renderFooterLink(link)}
                </li>)}
            </ul>
          </div>

          {/* Services Links */}
          <div>
            <h4 className="font-semibold text-foreground mb-4">Services</h4>
            <ul className="space-y-3">
              {footerLinks.services.map(link => <li key={link.label}>
                  {renderFooterLink(link)}
                </li>)}
            </ul>
          </div>

          {/* Resources Links */}
          <div>
            <h4 className="font-semibold text-foreground mb-4">Resources</h4>
            <ul className="space-y-3">
              {footerLinks.resources.map(link => <li key={link.label}>
                  {renderFooterLink(link)}
                </li>)}
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-border mt-12 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <p className="text-sm text-muted-foreground">
              © {currentYear} Contencraft. All rights reserved.
            </p>
            <div className="flex space-x-6">
              <a href="#" className="text-sm text-muted-foreground hover:text-foreground transition-colors">
                Privacy Policy
              </a>
              <a href="#" className="text-sm text-muted-foreground hover:text-foreground transition-colors">
                Terms of Service
              </a>
              <a href="#" className="text-sm text-muted-foreground hover:text-foreground transition-colors">
                Cookie Policy
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>;
};
export default Footer;